import React, { useEffect, useState } from 'react';
import { chartModes } from '../../helpers/agentDataCalculators';
import { agentProfileButtons as apb } from '../../constants/agentProductionConstants';
import { DropdownButton, DropdownButtonItem } from '@helix/dropdown-button';

const VolumeUnitsToggle = ({ defaultMode, parentSetMode }) => {
    if (!defaultMode || !parentSetMode) return;
    
    const [mode, setMode] = useState(defaultMode);  

    const handleModeClick = modeToSet => {
        setMode(modeToSet);
        parentSetMode(modeToSet);
    };

    useEffect(() => {
        if (!defaultMode) return;
        setMode(defaultMode);
        parentSetMode(defaultMode);
    }, [defaultMode]);

    const options = [
        { label: apb.volumeBtn.label, value: chartModes.VOLUME },
        { label: apb.unitsBtn.label, value: chartModes.UNITS }
    ];

    return (
        <div className="volume-units-toggle-wrapper ml-3">
            <DropdownButton
                label={options.find(opt => opt.value === mode)?.label}
                value={mode}
                removeSplit={true}
                size="small"
            >
                {options?.map((option, index) => (
                    <DropdownButtonItem
                        id={option.value}
                        key={index}
                        onClick={({ id }) => handleModeClick(id)}
                        textLabel={option.label}
                        value={option.value}
                        size="small"
                    >
                        {option.label}
                    </DropdownButtonItem>
                ))}
            </DropdownButton>
        </div>
    );
};

export default VolumeUnitsToggle;
